import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TemplateList from '../templates/List.template';
import DrawerComponent from '../../components/common/Drawer.component';
import HandoverEditPage from './edit/HandoverEdit.page';
import SendMailListAction from '../../components/actions/SendMailListAction';
import handover from '../../module/handover';
import dayjs from 'dayjs';

const HandoverListPage = () => {
    const [openItem, setOpenItem] = useState(null);
    const dispatch = useDispatch();
    const { jwt } = useSelector((state) => state.login);
    const query = useSelector(handover.query.all.selector);

    const handleOpenDrawer = useCallback((item) => {
        setOpenItem(item);
    }, []);

    const handleCloseDrawer = useCallback(() => {
        setOpenItem(null);
    }, []);


    const refreshList = useCallback(() => {
        dispatch(
            handover.query.all.action({
                settings: handover.query.all.settings,
                token: jwt,
                query: {
                    ...query,
                    start_date:
                        query?.start_date && dayjs(query.start_date).isValid()
                            ? dayjs(query.start_date).startOf('day').format('YYYY-MM-DDTHH:mm:ss')
                            : query?.start_date ?? null,
                    end_date:
                        query?.end_date && dayjs(query.end_date).isValid()
                            ? dayjs(query.end_date).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
                            : query?.end_date ?? null,
                    populate: handover.query.all.populate,
                },
            })
        );
    }, [dispatch, jwt, query]);

    return (
        <>
            <TemplateList
                module={handover}
                extraActions={<SendMailListAction module={handover} />}
                onItemClick={handleOpenDrawer}
            />

            {!!openItem && (
                <DrawerComponent
                    defaultOpen={!!openItem}
                    onClose={handleCloseDrawer}
                >
                    <HandoverEditPage
                        module={handover}
                        id={openItem?.id}
                        onSuccess={refreshList}
                    />
                </DrawerComponent>
            )}
        </>
    );
};

export default HandoverListPage;